// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"97167b0e","80":"fc0ac416","310":"b690eccf","325":"39d8ca05","411":"a52b53b8","529":"07d20a10","623":"ae857522","699":"7eb20b54","715":"1c6566bb","892":"1db78500"}[chunkId] + ".chunk.js";
};